import React, { useState, useEffect } from 'react';
import { HiMenuAlt3, HiX } from 'react-icons/hi';
import { useLanguage } from '../../i18n/LanguageContext';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, setLanguage, t, languageOptions } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: t('nav.links.why'), href: '#why' },
    { label: t('nav.links.solutions'), href: '#solutions' },
    { label: t('nav.links.platform'), href: '#demo' },
    { label: t('nav.links.team'), href: '#team' },
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        <a href="#home" className="navbar__logo">
          <img
            src="/Logo.png"
            alt={t('brand.logoAlt')}
            className="navbar__logo-img"
          />
          <div className="navbar__logo-text">
            <span className="navbar__logo-title">MAI</span>
            <span className="navbar__logo-subtitle">{t('brand.subtitle')}</span>
          </div>
        </a>

        <div className={`navbar__links ${isMobileMenuOpen ? 'navbar__links--open' : ''}`}>
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="navbar__link"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a href="#contact" className="navbar__cta" onClick={() => setIsMobileMenuOpen(false)}>
            {t('nav.cta')}
          </a>
          <div className="navbar__lang">
            <label className="navbar__lang-label" htmlFor="lang-select">
              {t('nav.languageLabel')}
            </label>
            <select
              id="lang-select"
              className="navbar__lang-select"
              value={language}
              onChange={(e) => {
                setLanguage(e.target.value);
                setIsMobileMenuOpen(false);
              }}
              aria-label={t('nav.languageLabel')}
            >
              {languageOptions.map((option) => (
                <option key={option.code} value={option.code}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <button
          className="navbar__mobile-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={t('nav.toggleLabel')}
        >
          {isMobileMenuOpen ? <HiX size={24} /> : <HiMenuAlt3 size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
